export default 'liberty/use-logical-spec';
